/**
 * Отложенный переход к профилю по ссылке `/u/<ник>` (стори 18.3).
 *
 * <p>Ссылку открывают в двух состояниях, и оба обязаны сработать: приложение уже запущено
 * (событие `url`) и приложение поднимается с нуля (`getInitialURL`). Во втором случае ник
 * приходит раньше, чем смонтирован список чатов, а у человека без аккаунта — ещё и раньше
 * входа. Поэтому ник буферизуется здесь и ждёт того, кто умеет открыть диалог.
 *
 * <p>Ровно та же схема, что у {@code notifications/openDruzhinaBridge}: два разных буфера с
 * одинаковой задачей развели бы поведение при холодном старте.
 */

type Listener = (handle: string) => void;

let listener: Listener | null = null;
let pendingHandle: string | null = null;

/** Ник из ссылки. Если открывать пока некому — ждёт подписчика (в том числе через вход). */
export function requestOpenProfileByHandle(handle: string): void {
  if (listener) {
    listener(handle);
    return;
  }
  pendingHandle = handle;
}

export function subscribeOpenProfileByHandle(fn: Listener): () => void {
  listener = fn;
  if (pendingHandle) {
    const h = pendingHandle;
    pendingHandle = null;
    fn(h);
  }
  return () => {
    if (listener === fn) listener = null;
  };
}
